import { useContext, useEffect } from "react";
import { VideoContext } from "../contexts/VideoContext";

/**
 * Custom hook to synchronize video data provided from a
 * given routes loader to send to the VideoManager.
 * It ensures that when a new route is loaded with the
 * associated video data, the video is properly uploaded
 * in the player. This is done to prevent black screens
 * between routes.
 *
 * The binary data of the next video is spliced into the
 * current playing video to ensure that the video source
 * remains the same. Video elements on TV's behave differently
 * than desktop/mobile. When their source changes,
 * the entire screen goes black for a second.
 *
 * @param data the binary buffer of data for the
 * loaded video for the route.
 */
export function useSyncVideoData(
	data: ArrayBuffer,
	contentType: string,
	name: string,
	navigateAfter?: string,
	shouldPlayImmediately: boolean = true,
) {
	const { videoManagerRef } = useContext(VideoContext);

	useEffect(() => {
		if (!videoManagerRef.current) return;
		videoManagerRef.current.show({
			data,
			navigateAfter,
			shouldPlayImmediately,
			contentType,
			name,
		});
	}, [data, videoManagerRef]);

	return null;
}
